export var INPUT_ID = {
    SET_URL: 'setUrl'
};
export var OUTPUT_ID = {
    HEADERS: 'headers'
};
export var INIT_READY = 0;
export var URL_READY = 1;
export var PARAMS_READY = 2;
export var READY = 3;
